<app-guest>
  <h1 class="mb-3 fw-bold fs-4">Please log in</h1>
  <div class="overflow-hidden">
    <div id="formslide" class="d-flex">
      <form class="p-3 w-50" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text" id="login-icon"><i class="bi bi-person-fill"></i></span>
            <input type="text" class="form-control" id="name" placeholder="Your email address"
                   aria-describedby="login-icon" formControlName="email" autocomplete="email">
          </div>
        </div>
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text" id="password-icon"><i class="bi bi-lock-fill"></i></span>
            <input type="password" class="form-control" id="password" placeholder="Your password"
                   aria-describedby="password-icon" formControlName="password"
                   autocomplete="current-password">
          </div>
        </div>
        <div class="mb-3 text-start">
          <label>
            <input class="form-check-input me-2" type="checkbox" formControlName="rememberMe">
            Remember me next time
          </label>
        </div>
        <div class="d-grid mb-3">
          <button type="submit" class="btn btn-primary fw-bold p-lg-3 shadow-sm" id="signinbtn"
                  [disabled]="loginForm.invalid">Sign In<i class="bi bi-arrow-right-short"></i></button>
        </div>
        <div class="text-center small">
          <a routerLink="/password-lost">Forgot your password?</a><br>
          Not registered? <a routerLink="/register">Click here</a>
        </div>
      </form>
    </div>
  </div>
</app-guest>
